import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useNursing } from "./NursingLayout";
import PublicAcademicsPage from "@/components/PublicAcademicsPage";

export default function Academics() {
  const data = useNursing();
  const docs = data.academics || [];
  return (
    <div data-testid="nur-ac-wrap">
      <PageHero eyebrow="Academic Resources" title="Academics" />
      <PageBody>
        <PublicAcademicsPage docs={docs} theme="emerald" testidPrefix="nur-ac" />
      </PageBody>
    </div>
  );
}
